import React from "react";
import dataTablesDataTables from "datatables.net-dt";
import { ErrorMessage, FieldArray } from "formik";
import {Select} from "@appkit4/react-components/select"
import PropTypes from 'prop-types';

function InternalContacts(props) {
  let { values,handleChange, handleBlur,role } = props;

  let disabledFields;
   if (role === "analyst" || role === "manager") {
    disabledFields = true
   }
  else {
    disabledFields = false //Can be changed according to future requirement.
  }

  
  return (
    <div>
      <FieldArray
        name="InternalContacts"
        render={(arrayHelpers) =>
          values.InternalContacts.map((item, index) => {
            return (
              <div className="row m-0 mb-2" key="index">
                <div className="col-sm-4">
                  <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                    <label className="cv-input-label">
                      User name<span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      searchable={true}
                      className="cv-input-field"
                      data={props.requestedBy}
                      dropdownAlwaysDown={false}
                      labelKey="user_name"
                      valueKey="user_id"
                      value={values.InternalContacts[index].username}
                      onSelect={(e) =>
                        handleChange(`InternalContacts[${index}].username`)({
                          target: { value: e },
                        })
                      }
                      placeholder="Select Username"
                      disabled={disabledFields}
                    >
                    </Select>
                  </div>
                  <span style={{ color: "#ff0000" }}>
                    <ErrorMessage
                      name={`InternalContacts[${index}].username`}
                    />
                  </span>
                </div>
                <div className={"col-sm-3"}>
                  <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                    <label className="cv-input-label">
                      Department<span className="asterisk-required">*</span>
                    </label>
                    <Select
                      showSearchOnToggle={true}
                      dropdownRenderMode="portal"
                      searchable={true}
                      className="cv-input-field"
                      data={props.departments}
                      dropdownAlwaysDown={false}
                      valueKey="vendor_department_id"
                      labelKey="vendor_department_name"
                      value={values.InternalContacts[index].department}
                      onSelect={(e) =>
                        handleChange(`InternalContacts[${index}].department`)({
                          target: { value: e },
                        })
                      }
                      placeholder="Select Department"
                      disabled={disabledFields}
                    >
                    </Select>
                  </div>
                  <span style={{ color: "#ff0000" }}>
                    <ErrorMessage
                      name={`InternalContacts[${index}].department`}
                    />
                  </span>
                </div>
                <div className="col-sm-4">
                  <div className={disabledFields ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
                    <label className="cv-input-label">
                      Role in project<span className="asterisk-required">*</span>
                    </label>
                    <input
                      className={disabledFields ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
                      type="text"
                      value={values.InternalContacts[index].roleInProject}
                      onChange={handleChange(
                        `InternalContacts[${index}].roleInProject`
                      )}
                      name="roleInProject"
                      placeholder={"Add Role In Project"}
                      disabled={disabledFields}
                    />
                  </div>
                  <span style={{ color: "#ff0000" }}>
                    {" "}
                    <ErrorMessage
                      name={`InternalContacts[${index}].roleInProject`}
                    />
                  </span>
                </div>
                {index === dataTablesDataTables.length - 1 ? (
                  <div className="col-sm-1">
                    <span
                      onClick={() =>
                        arrayHelpers.push({
                          username: "",
                          department: "",
                          roleInProject: "",
                        })
                      }
                      className="Appkit4-icon icon-circle-plus-outline pointer add-fill"
                    ></span>
                    {index === dataTablesDataTables.length - 1 &&
                      values.InternalContacts.length > 1 ? (
                      <span
                        onClick={() => arrayHelpers.pop()}
                        className="Appkit4-icon icon-circle-minus-outline pointer add-fill mt-1"
                      ></span>
                    ) : null}
                  </div>
                ) : null}
              </div>
            );
          })
        }
      />
    </div>
  );
}
InternalContacts.propTypes = {
  values: PropTypes.object,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
  role:PropTypes.string,
  requestedBy:PropTypes.array,
  departments:PropTypes.array
}
export default InternalContacts;
